import { BodyR, HeadingRegular } from '@pensionbee/honeypot-ui';
import Head from 'next/head';
import { ThemedImage } from '@/domains/theme/ThemedImage';
import { usePlatformInfo } from '@/domains/shared/hooks/useIsNative';

const NoNetworkScreen = () => {
  const { isNative } = usePlatformInfo();

  const errorMessageBody = `${isNative ? 'You need to be online to access the PensionBee app.' : 'You need to be online to access the PensionBee website.'} Please check your network settings and try again.`;
  return (
    <>
      <Head>
        <title>Unable to connect | PensionBee</title>
      </Head>

      <div className="flex flex-col items-center justify-center px-20 py-40 text-center max-w-lg mx-auto">
        {isNative && (
          <ThemedImage
            name="noNetworkConnection"
            alt="No Network Connection"
            className="h-[150px] sm:h-[200px]"
          />
        )}
        <HeadingRegular className="pt-28 pb-20">
          Unable to Connect
        </HeadingRegular>
        <BodyR>{errorMessageBody}</BodyR>
      </div>
    </>
  );
};

export default NoNetworkScreen;
